<navbar [exibeMenu]="false" [siglaMarca]="siglaMarca"></navbar>
<div>
  <h2 class="mensagem color-{{siglaMarca}}">{{mensagem}}</h2>
</div>
